<div *ngIf="reportType === 'All Briefly'">
  <div
    class="report-container"
    id="print-section"
    style="font-family: Arial, sans-serif; border: 1px solid black; margin-left: 10 mm; padding: 0;"
  >
    <!-- ===== HEADER SECTION ===== -->
    <table
      style="width: 100%; border-collapse: collapse; border: 1px solid black; background-color: #f8f9fa;"
    >
      <!-- <tr>
        <td style="font-size: 16px; font-weight: bold; text-align: left; white-space: nowrap; padding: 4px 6px;">
          हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - पुस्तक विभाग
        </td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 4px 6px;">
          Book Payment Receipt Ledger
        </td>
        <td style="font-size: 14px; text-align: right; white-space: nowrap; padding: 4px 6px;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

      <tr style="border-top: 1px solid black;">
        <td></td>
        <td style="font-size: 15px; font-weight: bold; text-align: center; padding: 2px 6px;">
          All Briefly Report
        </td>
        <td style="font-size: 14px; text-align: right; white-space: nowrap; padding: 2px 6px;">
          Date: {{ startDate | date:'dd-MM-yyyy' }} - {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr> -->

       <tr>
                    <th colspan="2" class="br-bottom br-leftt br-right br-top" style="border:none; font-size: 16px; font-weight: bold;border-bottom: 1px solid black;border-right: 1px solid black;">
                        हिंदुस्तान प्रकाशन संस्था 
                    </th>
                    <th colspan="3" class="br-bottom br-right br-top" style="border:none; font-size: 16px;text-align: center;font-weight: bold;border-bottom: 1px solid black;border-right: 1px solid black;">
                        Book Payment Receipt Report
                    </th>
                    <th colspan="4" class="br-bottom br-right br-top" style="border:none; font-size: 16px;border-bottom: 1px solid black;border-right: 1px solid black;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
                    </th>
                </tr>
                <tr>
                    <th colspan="2" class="br-bottom br-leftt br-right" style="border:none;  font-size: 16px;font-weight: bold;text-align: center;border-right: 1px solid black;">
                     विवेक पुस्तक प्रकाशन
                    </th>
                    <th colspan="3" class="br-bottom br-right" style="border:none; font-size: 16px;text-align: center;font-weight: bold;border-right: 1px solid black;">
                       All Briefly 
                    </th>
                    <th colspan="4" class="br-bottom br-right" style="border:none; font-size: 16px;border-right: 1px solid black;">
                        Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
                    </th>
                </tr>
    </table>

    <!-- ===== MAIN TABLE ===== -->
    <div class="table-responsive" style="margin: 0;">
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; font-size: 14px;">
        <thead>
          <tr style="background-color: #f1f1f1; text-align: center; font-weight: bold;">
            <th style="border: 1px solid black; padding: 4px;">Receipt Date</th>
            <th style="border: 1px solid black; padding: 4px;">Receipt No</th>
            <th style="border: 1px solid black; padding: 4px;">Book Seller Name</th>
            <th style="border: 1px solid black; padding: 4px;">Received Amount</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let office of PaymentBookOffInDFormBenas">

            <!-- Office Representative Header -->
            <tr >
              <td colspan="4"
                  style="text-align: center; font-weight: bold; border-top: 1px solid black;border-left: 1px solid black;border-bottom: 1px solid black; padding: 3px 4px;">
                Office Representative: {{ office.office_rep_name }}
              </td>
            </tr>

            <!-- Representative Loop -->
            <ng-container *ngFor="let rep of office.rep_data">

              <!-- Rep Header -->
              <tr style="background-color: #f9f9f9;">
                <td colspan="4"
                    style="font-weight: bold; border: 1px solid black; padding: 3px 4px;">
                  Representative: {{ rep.rep_name }}
                </td>
              </tr>

              <!-- Seller Rows -->
              <tr *ngFor="let seller of rep.book_sellers" style="text-align: center;">
                <td style="white-space: nowrap; border: 1px solid black; padding: 3px;">
                  {{ seller.receipt_date }}
                </td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 3px;">
                  {{ seller.receipt_no }}
                </td>
                <td style="white-space: nowrap; text-align: left; border: 1px solid black; padding: 3px 4px;">
                  {{ seller.book_seller_name }}
                </td>
                <td style="text-align: right; border: 1px solid black; padding: 3px;">
                  {{ seller.rcv_amt  }}
                </td>
              </tr>

              <!-- Rep Total -->
              <tr>
                <td colspan="3"
                    style="text-align: right; font-weight: bold; border: 1px solid black; padding: 3px;">
                  Total for Rep: {{ rep.rep_name }}
                </td>
                <td style="text-align: right; font-weight: bold; border: 1px solid black; padding: 3px;">
                  {{ rep.rep_total_rcv  }}
                </td>
              </tr>
            </ng-container>

            <!-- Office Total -->
            <tr style="background-color: #f4b084;">
              <td colspan="3"
                  style="text-align: right; font-weight: bold; border-top: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding: 3px;">
                Total for Office Rep: {{ office.office_rep_name }}
              </td>
              <td style="text-align: right; font-weight: bold; border-top: 1px solid black;border-bottom: 1px solid black;border-right: 1px solid black; padding: 3px;">
                {{ office.total_rcv_amt  }}
              </td>
            </tr>
          </ng-container>
        </tbody>

        <!-- Grand Total -->
        <tfoot>
          <tr style="background-color: #c8753f; font-weight: bold;">
            <td colspan="3"
                style="text-align: right; border: 1px solid black; padding: 3px;">
              Grand Total:
            </td>
            <td style="text-align: right; border: 1px solid black; padding: 3px;">
              {{ PaymentbookOffInDTotal2 }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- ===== ACTION BUTTONS ===== -->
  <div class="button-container noPrint" style="margin-top: 10px; text-align: center;">
    <button mat-raised-button color="primary" (click)="exportExcel('Book_InDetail_Officewise')">📊 Export</button>
    <button mat-raised-button color="accent" (click)="printPageA4()">🖨️ Print</button>
    <button mat-button mat-dialog-close>❌ Close</button>
  </div>
</div>
